// extracted by mini-css-extract-plugin
module.exports = {"panel":"Panel_panel__2s4t9","info":"Panel_info__227G3","btns":"Panel_btns__3dqZ7","button":"Panel_button__3VSol"};